const getArc = ({
  rx = 0, ry = 0, xAxisRotation = 0, largeArcFlag = 0, sweepFlag = 0, x = 0, y = 0, complete = false,
}) => `A ${rx} ${ry} ${xAxisRotation} ${largeArcFlag} ${sweepFlag} ${x} ${y}${ complete ? ' z' : '' }`

export { getArc }
